module.exports = __webpack_public_path__ + "static/img/sdyc1.8b98ec89.png";